import type { ReportOrgAuditEventRequest, ReportOrgAuditEventResponse } from '@nadoutong/contracts';
import { platformApiRequest } from '../api/client.ts';

/**
 * Client-reported export audit event (#178).
 *
 * POST `/v1/org/audit/events` — session-scoped write from router #2312.
 * PR #179 guessed `POST /v1/orgs/{orgId}/audit-events` (the GET listing
 * collection); the live route is `/v1/org/audit/events` with
 * {@link ReportOrgAuditEventRequest}. Call is still best-effort:
 *
 *  - 404: the route has not shipped in this environment; swallow.
 *  - network / status 0: the console is ahead of the API; swallow.
 *
 * Either way the spreadsheet is the product. A missing audit row must
 * not toast, block, or fail the download. Other HTTP errors are
 * swallowed for the same reason — this sidecar cannot own the click.
 */
export async function reportExportAuditEvent(
  fetchImpl: typeof fetch,
  event: ReportOrgAuditEventRequest,
): Promise<void> {
  try {
    await platformApiRequest<ReportOrgAuditEventResponse>(
      '/v1/org/audit/events',
      { method: 'POST', body: event },
      fetchImpl,
    );
  } catch {
    // 404 / network / any other failure: see the file header. The
    // spreadsheet is the product; this sidecar cannot own the click.
    return;
  }
}
